export class TilesAreBeingProcessedError extends Error {}
